import type { ComponentPropsWithRef, ReactNode } from 'react';
import { cn } from '../lib/cn';
import { navItemStyles } from './nav-item-styles';

export function NavButton({
  icon,
  label,
  count,
  active = false,
  className,
  ...props
}: Omit<ComponentPropsWithRef<'button'>, 'children'> & {
  icon: ReactNode;
  label: ReactNode;
  count?: number | undefined;
  active?: boolean;
}) {
  return (
    <button
      type="button"
      aria-current={active ? 'page' : undefined}
      className={cn(navItemStyles, className)}
      {...props}
    >
      {icon}
      <span className="flex-1 truncate">{label}</span>
      {count !== undefined && count > 0 && (
        <span className="tabular text-xs text-text-3">{count}</span>
      )}
    </button>
  );
}
